<template>
  <div class="template" @click="template_click()">
    <header class="p-3">
      <nav
        class="navbar navbar-fixed-top navbar-dark navbar-expand-lg navbar-kts"
      >
        <div class="container-xl head-mobile">
          <div class="div-top-bar-m">
            <div class="col-sm-5 nav">
              <button
                @click="navbarmobile"
                class="navbar-toggler second-button"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent23"
                aria-controls="navbarSupportedContent23"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <div id="navbar-icon" class="animated-icon2">
                  <span></span><span></span><span></span><span></span>
                </div>
              </button>
            </div>
            <div class="col-sm-2 text-center">
              <a href="/" class="navbar-logo d-lg-none"
                ><img class="logo-kts-top" src="../public/logo/LogoText_w.png"
              /></a>
            </div>
            <div class="col-sm-5"></div>
          </div>
        </div>
      </nav>

      <!-- sidebar -->
      <div class="topbar" :class="class_sidebar">
        <div class="wrap-sidebar">
          <div class="wrap-menu">
            <nav class="menu-navbar">
              <ul>
                <li>
                  <router-link @click="link_click" to="/">HOME</router-link>
                </li>
                <li>
                  <router-link @click="link_click" to="/new%20&%20trending"
                    >NEW & TRENDING</router-link
                  >
                </li>
                <li>
                  <a @click="drop_menu_df()"
                    ><span>DIFFUSERS</span>
                    <svg
                      :class="svg_active_df"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="svg-icon ml-auto w-5 h-5 transition-transform duration-200 text-brand-500"
                    >
                      <path
                        d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                  <ul class="sub-menu-navbar" :class="sub_menu_mobile_df">
                    <li>
                      <router-link @click="link_click" to="/diffusers"
                        >diffusers</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        @click="link_click"
                        to="/diffusers/fruity scent reed diffuser"
                        >fruity scent reed diffuser</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        @click="link_click"
                        to="/diffusers/perfume reed diffuser"
                        >perfume reed diffuser</router-link
                      >
                    </li>
                  </ul>
                </li>

                <li>
                  <a @click="drop_menu_rs()"
                    ><span>ROOM & FABRIC SPRAY</span>
                    <svg
                      :class="svg_active_rs"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="svg-icon ml-auto w-5 h-5 transition-transform duration-200 text-brand-500"
                    >
                      <path
                        d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                  <ul class="sub-menu-navbar" :class="sub_menu_mobile_rs">
                    <li>
                      <router-link
                        @click="link_click"
                        to="/room%20&%20fabric%20spray"
                        >room & fabric spray</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        @click="link_click"
                        to="/room%20&%20fabric%20spray/fruity scent room & fabric spray"
                        >fruity scent room & fabric spray</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        @click="link_click"
                        to="/room%20&%20fabric%20spray/perfume room & fabric spray"
                        >perfume room & fabric spray</router-link
                      >
                    </li>
                  </ul>
                </li>

                <li>
                  <a @click="drop_menu_ac()"
                    ><span>ACCESSORIES</span>
                    <svg
                      :class="svg_active_ac"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="svg-icon ml-auto w-5 h-5 transition-transform duration-200 text-brand-500"
                    >
                      <path
                        d="M4.79175 7.396L10.0001 12.6043L15.2084 7.396"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      ></path>
                    </svg>
                  </a>
                  <ul class="sub-menu-navbar" :class="sub_menu_mobile_ac">
                    <li>
                      <router-link @click="link_click" to="/accessories"
                        >accessories</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        @click="link_click"
                        to="/accessories/refill reed diffuser"
                        >refill reed diffuser</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        @click="link_click"
                        to="/accessories/refill reed sticks"
                        >refill reed sticks</router-link
                      >
                    </li>
                  </ul>
                </li>

                <li>
                  <router-link @click="link_click" to="/about"
                    >ABOUT HATEBERRY</router-link
                  >
                </li>
                <li class="follow">
                  <div class="follow-icon">
                    <a
                      v-for="(resultS, i) in result"
                      :key="i"
                      target="_blank"
                      :href="resultS.link"
                      :title="resultS.name"
                    >
                      <img
                        class="logo-footer"
                        :src="
                          'https://hateberryscent.com/images/logo/' +
                          resultS.image
                        "
                    /></a>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <!-- sidebar -->

      <div class="container head-pc">
        <div class="head-pc">
          <div class="row">
            <div class="col div-logo">
              <img src="../public/logo/LogoText_w.png" />
            </div>
          </div>
          <div
            class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start"
          >
            <ul class="nav link_top_menu col-12">
              <li>
                <router-link class="router-link" to="/">HOME</router-link>
              </li>
              <li>
                <router-link class="router-link" to="/new%20&%20trending"
                  >NEW & TRENDING</router-link
                >
              </li>
              <li>
                <a class="router-link" @click="dropdown_diffusers()"
                  >DIFFUSERS</a
                >
                <div class="dropdown">
                  <div
                    class="dropdown-menu"
                    :class="class_dd_diffusers"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <router-link class="dropdown-item" to="/diffusers"
                      >diffusers</router-link
                    >

                    <router-link
                      class="dropdown-item"
                      to="/diffusers/fruity scent reed diffuser"
                      >fruity scent reed diffuser</router-link
                    >

                    <router-link
                      class="dropdown-item"
                      to="/diffusers/perfume reed diffuser"
                      >perfume reed diffuser</router-link
                    >

                    <router-link
                      class="dropdown-item"
                      to="/diffusers/gourmand scent reed diffuser"
                      >gourmand scent reed diffuser</router-link
                    >
                  </div>
                </div>
              </li>

              <li>
                <a class="router-link" @click="dropdown_room_fabric_spray()"
                  >ROOM & FABRIC SPRAY</a
                >
                <div class="dropdown">
                  <div
                    class="dropdown-menu"
                    :class="class_dd_room_fabric_spray"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <router-link
                      class="dropdown-item"
                      to="/room%20&%20fabric%20spray"
                      >room & fabric spray</router-link
                    >

                    <router-link
                      class="dropdown-item"
                      to="/room%20&%20fabric%20spray/fruity scent room & fabric spray"
                      >fruity scent room & fabric spray</router-link
                    >

                    <router-link
                      class="dropdown-item"
                      to="/room%20&%20fabric%20spray/perfume room & fabric spray"
                      >perfume room & fabric spray</router-link
                    >
                  </div>
                </div>
              </li>

              <li>
                <a class="router-link" @click="dropdown_accessories()"
                  >ACCESSORIES</a
                >
                <div class="dropdown">
                  <div
                    class="dropdown-menu"
                    :class="class_dd_accessories"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <router-link class="dropdown-item" to="/accessories"
                      >accessories</router-link
                    >

                    <router-link
                      class="dropdown-item"
                      to="/accessories/refill reed diffuser"
                      >refill reed diffuser</router-link
                    >

                    <router-link
                      class="dropdown-item"
                      to="/accessories/refill reed sticks"
                      >refill reed sticks</router-link
                    >
                  </div>
                </div>
              </li>

              <li>
                <router-link class="router-link" to="/about"
                  >ABOUT HATEBERRY</router-link
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="back-link">
          {{ link_nav($route.fullPath) }}
          <ul v-if="$route.fullPath !== '/'">
            <li>
              <router-link class="router-link-at" to="/">HOME</router-link>
            </li>
            <ul v-for="(path, itemIndex) in nav_path" :key="path">
              <li><p class="a">/</p></li>
              <li>
                <p
                  v-if="
                    (nav_path.length > 1) & (itemIndex == nav_path.length - 1)
                  "
                  class="router-link-non"
                >
                  {{ path }}
                </p>
                <p v-else-if="nav_path.length == 1" class="router-link-non">
                  {{ path }}
                </p>

                <router-link
                  v-else-if="nav_path.length == 2"
                  class="router-link-at"
                  :to="'/' + encodeURI(path)"
                >
                  {{ path }}
                </router-link>

                <router-link
                  v-else-if="nav_path.length == 3"
                  class="router-link-at"
                  :to="
                    path == 'diffusers' ? '/diffusers' : '/diffusers/' + path
                  "
                >
                  {{ path }}
                </router-link>
              </li>
            </ul>
          </ul>
        </div>
      </div>
    </header>

    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </div>
</template>

<script>
//import { useRouter } from "vue-router";
//const router = useRouter();
import axios from "axios";
export default {
  name: "App",
  provide() {
    return {
      location: "https://www.hateberryscent.com",
    };
  },
  data: function () {
    return {
      dd_diffusers: false,
      dd_accessories: false,
      dd_room_fabric_spray: false,
      nav_path: [],
      result: [],
      // class //
      class_dd_diffusers: "d-non",
      class_dd_accessories: "d-non",
      class_dd_room_fabric_spray: "d-non",

      isActive_contact: false,
      isActive_location: false,
      isActive_sidebar: false,
      isActive_sidebar_mobile_df: false,
      isActive_sidebar_mobile_rs: false,
      isActive_sidebar_mobile_ac: false,
      sub_menu_mobile_df: "d-none",
      sub_menu_mobile_rs: "d-none",
      sub_menu_mobile_ac: "d-none",

      class_sidebar: "",

      svg_active_df: "",
      svg_active_rs: "",
      svg_active_ac: "",
    };
  },
  mounted() {
    axios
      .get("https://www.hateberryscent.com/php-api/index.php/social-media/")
      .then((response) => {
        const { result } = response.data;
        this.result = result;
      });
  },
  methods: {
    navbarmobile() {
      let element = document.getElementById("navbar-icon");
      element.classList.toggle("open");
      if (this.isActive_sidebar == false) {
        this.isActive_sidebar = true;
        this.class_sidebar = "active";
      } else {
        this.isActive_sidebar_mobile = false;
        this.svg_active = "";
        this.sub_menu_mobile = "d-none";

        this.isActive_sidebar = false;
        this.class_sidebar = "";
      }
    },
    template_click: function () {
      if (this.dd_diffusers == true) {
        this.class_dd_diffusers = "d-block";
      } else {
        this.class_dd_diffusers = "d-non";
      }
      this.dd_diffusers = false;

      if (this.dd_accessories == true) {
        this.class_dd_accessories = "d-block";
      } else {
        this.class_dd_accessories = "d-non";
      }
      this.dd_accessories = false;

      if (this.dd_room_fabric_spray == true) {
        this.class_dd_room_fabric_spray = "d-block";
      } else {
        this.class_dd_room_fabric_spray = "d-non";
      }
      this.dd_room_fabric_spray = false;
    },
    dropdown_diffusers: function () {
      this.dd_diffusers = true;
    },
    dropdown_accessories: function () {
      this.dd_accessories = true;
    },
    dropdown_room_fabric_spray: function () {
      this.dd_room_fabric_spray = true;
    },
    link_nav: function (p) {
      this.nav_path = [];
      if (p !== "/") {
        let pArray = p.split("/");

        // console.log(pArray);
        pArray.forEach((element) => {
          if (element) {
            this.nav_path.push(decodeURI(element));
          }
        });
      }
      console.log(this.nav_path[0]);
    },
    drop_menu_df() {
      if (this.isActive_sidebar_mobile_df == false) {
        this.svg_active_df = "svg_active";
        this.sub_menu_mobile_df = "";
        this.isActive_sidebar_mobile_df = true;
      } else {
        this.svg_active_df = "";
        this.sub_menu_mobile_df = "d-none";
        this.isActive_sidebar_mobile_df = false;
      }
    },
    drop_menu_rs() {
      if (this.isActive_sidebar_mobile_rs == false) {
        this.svg_active_rs = "svg_active";
        this.sub_menu_mobile_rs = "";
        this.isActive_sidebar_mobile_rs = true;
      } else {
        this.svg_active_rs = "";
        this.sub_menu_mobile_rs = "d-none";
        this.isActive_sidebar_mobile_rs = false;
      }
    },
    drop_menu_ac() {
      if (this.isActive_sidebar_mobile_ac == false) {
        this.svg_active_ac = "svg_active";
        this.sub_menu_mobile_ac = "";
        this.isActive_sidebar_mobile_ac = true;
      } else {
        this.svg_active_ac = "";
        this.sub_menu_mobile_ac = "d-none";
        this.isActive_sidebar_mobile_ac = false;
      }
    },
    link_click() {
      let element = document.getElementById("navbar-icon");
      element.classList.toggle("open");

      this.isActive_sidebar_mobile = false;
      this.svg_active = "";
      this.sub_menu_mobile = "d-none";

      this.isActive_sidebar = false;
      this.class_sidebar = "";
    },
  },

  /* mounted() {
    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute(
      "src",
      "assets/vendors/js/vendor.bundle.base.js"
    );
    document.head.appendChild(recaptchaScript);
  },*/
};
</script>

<style>
@import "./assets/styles/variables.css";
@import "./assets/styles/app.css";
</style>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.7s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

:global(body) {
  font-family: "NORD-Light" !important;
  background-color: var(--background-color) !important;
}
</style>
